import { Routes, Route, Navigate } from "react-router-dom";

import FleetTransportations from "./FleetTransportations";

const fleetTransportationsRoutes = [
    {routeName: 'primary-transportation' , component: <FleetTransportations/>},
    {routeName: 'secondary-transportation' , component: <FleetTransportations/>},
    {routeName: 'cold-chain-transportation' , component: <FleetTransportations/>},
    {routeName: 'project-sepecializ-transportation' , component: <FleetTransportations/>},
    
];

const FleetTransportationsRoutes = () => {
    return (
    <Routes>
       {fleetTransportationsRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default FleetTransportationsRoutes;